export default "__VITE_ASSET__5jT0Mxrm__"